import { createContext, useContext, useEffect, useState } from "react";

export const AbilityContext = createContext();

export const Can = ({ I, a, this: subject, field, children }) => {
    const ability = useContext(AbilityContext);
    const [, forceUpdate] = useState(0);

    useEffect(() => {
        if (!ability?.on) return undefined;
        const unsubscribe = ability.on("updated", () => forceUpdate((n) => n + 1));
        return unsubscribe;
    }, [ability]);

    const allowed = !!ability?.can(I, subject ?? a, field);
    return typeof children === "function" ? children(allowed) : (allowed ? children : null);
};
